import React, { useState } from "react";
import { Container, Dialog, DialogContent, DialogTitle, IconButton, Tabs, Tab } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { DisplayOptions } from "./Display";
import { Devices } from "./Devices";
import { Notifications } from "./Notifications";
import useStyles from "./styles";

const Settings = ({ open, handleClose, devices, merchant_id }) => {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event, value) => {
    setTabValue(value);
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="settings-dialog" fullWidth={true} maxWidth={"md"}>
      <DialogTitle id="settings-dialog">
        Settings
        <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div className={classes.root}>
          <Tabs
            orientation="vertical"
            value={tabValue}
            onChange={handleTabChange}
            aria-label="Settings Tabs"
            className={classes.tabs}
          >
            <Tab label="Devices" {...a11yProps(0)} />
            <Tab label="Display" {...a11yProps(1)} />
            <Tab label="Notifications" {...a11yProps(2)} />
          </Tabs>
          {tabValue === 0 && (
            <TabPanel className={classes.root}>
              <Devices devices={devices} />
            </TabPanel>
          )}
          {tabValue === 1 && (
            <TabPanel className={classes.root}>
              <DisplayOptions merchant_id={merchant_id} devices={devices} />
            </TabPanel>
          )}
          {tabValue === 2 && (
            <TabPanel className={classes.root}>
              <Notifications merchant_id={merchant_id} />
            </TabPanel>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div role="tabpanel" aria-labelledby="tab-panel" {...other}>
      <Container fixed maxWidth="md" m={1}>
        {children}
      </Container>
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
};

export default Settings;
